import { useLocation, useNavigate } from 'react-router-dom';

export const useQueryParam = <T>(
  getParams: (searchParams: URLSearchParams) => T,
  setParams: (value: T, searchParams: URLSearchParams) => void,
): [T, (value: T) => void] => {
  const navigate = useNavigate();
  const location = useLocation();

  const getValue = () => {
    const searchParams = new URLSearchParams(window.location.search);
    return getParams(searchParams);
  };

  const setValue = (value: T) => {
    const searchParams = new URLSearchParams(window.location.search);

    setParams(value, searchParams);
    navigate({ search: searchParams.toString() }, { state: location.state });
  };

  return [getValue(), setValue];
};
